import React from "react";

// tour data

export const Profile_tour_data = [
  {
    content: <p>Begin crafting your Professional identity</p>,
    title: <h2>Welcome to Profile Page</h2>,
    locale: { skip: <p aria-label="skip">skip</p> },
    placement: "center",
    target: "body",
  },
  {
    content: (
      <React.Fragment>
        <p>This progress bar illustrates your profile completeness</p>
      </React.Fragment>
    ),
    title: <h2>Profile Progress</h2>,
    locale: { skip: <p aria-label="skip">skip</p> },
    target: "#profile-progress-container",
  },
  {
    content: (
      <React.Fragment>
        <p>Edit your account details here</p>
      </React.Fragment>
    ),
    title: <h2>Avatar Pencil Icon</h2>,
    locale: { skip: <p aria-label="skip">skip</p> },
    target: "#profile-avatar-icon",
  },
  {
    content: (
      <React.Fragment>
        <p>The cipher map visualizes your learning frequency</p>
      </React.Fragment>
    ),
    title: <h1>Cipher Map</h1>,
    locale: { skip: <p aria-label="skip">skip</p> },
    target: "#profile-cipher-map",
  },
  {
    content: (
      <React.Fragment>
        <h1>View Public Profile Button</h1>
        <p>Access and view your public profile</p>
      </React.Fragment>
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    target: "#view-public-profile-btn",
  },
];

export const Video_tour_data = [
  {
    content: (
      <p>
        Lights, camera, education! Dive into the reel deal. Let's get started!
      </p>
    ),
    title: <h2 style={{ marginBottom: "10px" }}>Welcome to Video course</h2>,
    locale: { skip: <p aria-label="skip">skip</p> },
    placement: "center",
    target: "body",
  },
  {
    content: (
      <React.Fragment>
        <p>Enroll to the course by clicking here</p>
      </React.Fragment>
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    target: ".video-enroll-btn",
  },
  {
    content: (
      <React.Fragment>
        <p>Engage by asking doubts and questions here</p>
      </React.Fragment>
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    target: ".comment-box-area",
  },
  // {
  //   content: (
  //     <React.Fragment>
  //       <p>Personalize your learning experience by adding notes</p>
  //     </React.Fragment>
  //   ),
  //   locale: { skip: <p aria-label="skip">skip</p> },
  //   placement: "center",
  //   target: "#id",
  // },
];

export const Home_tour_data = [
  {
    content: <p>Your Learning Buddy</p>,
    title: <h2>Welcome to CipherSchools</h2>,
    locale: { skip: <p aria-label="skip">skip</p> },
    placement: "center",
    target: "body",
  },
  {
    content: (
      <>
        <p style={{ paddingLeft: "5px", paddingRight: "5px" }}>
          Explore courses or creators with our search feature
        </p>
      </>
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 7,
    target: ".search-box",
  },
  {
    content: (
      <>
        <p>Stay informed with all your notifications here</p>
      </>
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    placement: "bottom-end",
    spotlightPadding: 5,
    offset: 0,
    target: "#nav-notification",
  },
  // ...(window.screen.width <= 961
  //   ? [
  //       {
  //         content: (
  //           <>
  //             <p>Accumulate points while learning with CipherSchools</p>
  //           </>
  //         ),
  //         locale: { skip: <p aria-label="skip">skip</p> },
  //         placement: "bottom-end",
  //         target: "#nav-cipher-points",
  //       },
  //     ]
  //   : []),
  {
    content: (
      <>
        <p>Accumulate points while learning with CipherSchools</p>
      </>
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    placement: "bottom-end",
    target: "#nav-cipher-points",
  },
];

// tour data for premium user
export const Batch_tour_data = (id) => [
  {
    target: "body",
    placement: "center",
    title: <p>Welcome!</p>,
    content: (
      <>
        <p>
          Before you begin your learning journey, lets take a look at the new
          updates made to enhance your learning experience on the platform!
        </p>
      </>
    ),
    data: {
      next: "/courses",
    },
    locale: { skip: "Skip" },
  },
  {
    target: "#msp-batches",
    // title: <h2>This is the Batch section</h2>,
    content: (
      <>
        <p>Click here to access the batches you are enrolled in.</p>
      </>
    ),
    data: {
      next: "/batches",
    },
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 5,
    disableBeacon: true,
  },
  {
    target: `#batches-${id}`,
    // title: <h2>Here is your Batch Card</h2>,
    content: (
      <>
        <p>Click on the batch card to access your batch related information.</p>
      </>
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    data: {
      previous: "/batches",
      next: `/batches/${id}`,
    },
    disableBeacon: true,
    spotlightPadding: 8,
  },

  {
    // target: "#batches-dashboard",
    target: "#batch-home",
    placement: "center",
    identifier: "Dash",
    content: (
      <p>
        Welcome to your batch dashboard, where you can access everything related
        to your course and batch.
      </p>
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    data: {
      next: `/batches/${id}`,
    },
    disableBeacon: true,
  },
  {
    // target: "#batches-dashboard",
    target: "#badges",
    placement: "bottom",
    identifier: "Badges",
    content: (
      <p>Earn badges by completing questions and unlock exciting rewards!</p>
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    data: {
      next: `/batches/${id}`,
    },
    disableBeacon: true,
  },
  {
    target: "#msp-syllabus",
    content: <p>Explore your course syllabus from here.</p>,
    identifier: "Syllabus",
    locale: { skip: <p aria-label="skip">skip</p> },
    data: {
      next: `/batches/${id}`,
    },
    spotlightPadding: 5,
  },
  {
    target: "#msp-calender",
    // title: <h2>calender</h2>,
    content: <p>Click on the calendar to know your course related timeline</p>,
    identifier: "Calendar",
    locale: { skip: <p aria-label="skip">skip</p> },
    data: {
      next: `/batches/${id}`,
    },
    spotlightPadding: 5,
  },
  {
    target: "#msp-test",
    // title: <h2>resource</h2>,
    content: <p>Click here to access your test</p>,
    identifier: "Tests",
    locale: { skip: <p aria-label="skip">skip</p> },
    data: {
      next: `/batches/${id}`,
    },
    spotlightPadding: 5,
  },
  {
    target: "#msp-assignments",
    title: <p>Assignments</p>,
    content: (
      <p>Click here to solve questions to get better grades in the course!</p>
    ),
    identifier: "Questions",
    locale: { skip: <p aria-label="skip">skip</p> },
    data: {
      next: `/batches/${id}`,
    },
    spotlightPadding: 5,
  },
  {
    target: "#msp-contents",
    title: <p>Contents</p>,
    content: <p>Browse the course content from here.</p>,
    identifier: "Contents",
    locale: { skip: <p aria-label="skip">skip</p> },
    data: {
      next: `/batches/${id}`,
    },
    spotlightPadding: 5,
  },
];

// tour constants
export const HOME_TOUR = "hometour";
export const VIDEO_TOUR = "videotour";
export const PROFILE_TOUR = "profiletour";
export const BATCH_TOUR = "batchtour";
